export default {
  bmap:{
    p_m:'/static/images/location.png'
  }
}
